import CloseIcon from '@mui/icons-material/Close';
import { Box, DialogTitle, IconButton } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { observer } from 'mobx-react-lite';
import { FC, Ref, forwardRef, useEffect } from 'react';
import UserAddressEditViewStore from '../stores/UserAddressEditViewStore';
import UserAddress from './UserAddress';

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface UserAddressDialogProps {
    userAddressEditViewStore: UserAddressEditViewStore;
}

const UserAddressDialog: FC<UserAddressDialogProps> = observer(({ userAddressEditViewStore }) => {
    const { isUserAddressDialogOpen, setIsUserAddressDialogOpen, initialize } = userAddressEditViewStore;

    useEffect(() => {
        initialize()
    }, [])

    const handleClose = () => {
        setIsUserAddressDialogOpen(false);
    };

    return (
        <Dialog
            onClose={handleClose}
            open={isUserAddressDialogOpen}
            maxWidth={"xs"}
            keepMounted={false}
            sx={{
                "& .MuiDialog-paper": {
                    width: "100%",
                    m: 1
                }
            }}>
            <DialogTitle>Adresa dostave</DialogTitle>
            <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
                sx={{
                    position: "absolute",
                    top: 8,
                    right: 8
                }}
            >
                <CloseIcon />
            </IconButton>

            <Box  pt={1} pb={2} pl={4} pr={4}>
                <UserAddress userAddressEditViewStore={userAddressEditViewStore} />
            </Box>
        </Dialog>
    );
});

export default UserAddressDialog;